import React from 'react';
import { IconProps } from '.';

const SvgSearchBold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M15.644 17.765A9.208 9.208 0 0 1 10.25 19.5a9.25 9.25 0 1 1 7.515-3.856l5.796 5.795-2.122 2.122-5.795-5.796Zm.856-7.515a6.25 6.25 0 1 1-12.5 0 6.25 6.25 0 0 1 12.5 0Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgSearchBold;
